import React, { useState ,useContext} from 'react'
import {AppFormItemProps,AppFormContext} from '../AppForm/index'
import {AppInput,AppInputProps} from '../AppInput'


export const AppFormItemInput = (props:AppFormItemProps) =>{
    
    const {onChange,formData} = useContext(AppFormContext);
    const inputProps = {...props} as AppInputProps;


    const handleChange = (value:string | number,text:string) =>{
        let itemProps = {...props,value} as AppFormItemProps ;
        onChange && onChange(itemProps);
    }


    return <AppInput {...inputProps} value={formData[props.keyName]} onChange={handleChange}/>
}


// WEBPACK FOOTER //
// ./src/qcc/AppFormItem/AppFormItemInput.tsx